import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";

export const createGroup = (payload) => {
  const url = getUrl("listGroup");
  return trackPromise(Call.post(url, payload));
};
export const editGroup = (data = {}) => {
  const {id = ""} = data;
  const url = getUrl("listGroup");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.patch(patchUrl, data));
};

export const getGroups = (pageUrl) => {
  const groupUrl = pageUrl ? pageUrl : getUrl("listGroup");
  return trackPromise(Call.get(groupUrl));
};

export const listPermissions = () => {
  const list_permissions = getUrl("listPermissions");
  return trackPromise(Call.get(list_permissions));
};

export const getGroupsLabelValueAsync = () => {
  const groupUrl = getUrl("group_label_value");
  return trackPromise(Call.get(groupUrl));
};

export const listUser = (payload = {}) => {
  const {excludeMe, userId} = payload;
  const url = getUrl("listUsers");
  return trackPromise(Call.get(`${url}${excludeMe ? `?exclude=${userId}` : ""}`));
};

export const deleteGroup = (id = "") => {
  const url = getUrl("listGroup");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};
